export enum AuthField {
    IDENTIFICATION = 'identificationNumber',
    IDENTIFICATION_TYPE = 'identificationType',
    PASSWORD = 'password',
    NEW_PASSWORD = 'newPassword',
    PASSWORD_CONFIRMATION = 'passwordConfirmation',
    CODE = 'passwordToken'
}
